import authors from "./authors";
import categories from "./categories";
import halls from "./halls";
import programs from "./programs";
import works from "./works";

export default {
    authors,
    categories,
    halls,
    programs,
    works,
};
